import { render, staticRenderFns } from "./PageViewer.vue?vue&type=template&id=3c9aeb78&scoped=true&"
import script from "./PageViewer.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PageViewer.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PageViewer.vue?vue&type=style&index=0&id=3c9aeb78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9aeb78",
  null
  
)

export default component.exports